module.exports = __webpack_public_path__ + "img/sidebar_rlsw_202627.e80c3d6c.png";